/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CashBackItem {
  id: string;
  [key: string]: any; // Allow other properties while enforcing id
}

interface SelectedSalesValue {
  name: string;
  value: number | boolean | null;
}

interface CashBackState {
  cashBack: CashBackItem[];
  selectedSalesValues: SelectedSalesValue[];
  totalPrice: number;
}

const initialState: CashBackState = {
  cashBack: [],
  selectedSalesValues: [],
  totalPrice: 0
};

export const { actions: cashBackActions, reducer: cashBackReducer } =
  createSlice({
    name: 'cashBack',
    initialState,
    reducers: {
      saveCashBackList: (
        state,
        action: PayloadAction<{
          cashBack: CashBackItem[];
          selectedSalesValues: SelectedSalesValue[];
          totalPrice: number;
        }>
      ) => {
        // Prevent duplicates in cashBack
        const newItems = action.payload.cashBack;
        const updatedIds = new Set(newItems.map(item => item.id));
        state.cashBack = [
          ...state.cashBack.filter(item => !updatedIds.has(item.id)),
          ...newItems
        ];
        // Update selectedSalesValues
        state.selectedSalesValues = action.payload.selectedSalesValues;
        // Update totalPrice
        state.totalPrice = action.payload.totalPrice;
      },
      removeCashBackItem: (state, action: PayloadAction<string>) => {
        state.cashBack = state.cashBack.filter(
          item => item.id !== action.payload
        );
      },
      clearCashBackList: state => {
        state.cashBack = [];
        state.selectedSalesValues = [];
        state.totalPrice = 0;
      }
    }
  });
